import { DxTraingCourseAction } from '../actions/dx-training/types'

export interface DxTrainingCourseReduxState {
  isSubmitting: boolean
  isSubmitted: boolean
  error: string
}

const initialState: DxTrainingCourseReduxState = {
  isSubmitting: false,
  isSubmitted: false,
  error: null,
}

const dxTrainingCourse = (
  state: DxTrainingCourseReduxState = initialState,
  action: DxTraingCourseAction
) => {
  switch (action.type) {
    case 'training-course/MARKING_COMPLETED':
      return { ...state, isSubmitting: true, isSubmitted: false, error: null }
    case 'training-course/MARK_COMPLETED_SUCCESS':
      return { ...state, isSubmitting: false, isSubmitted: true, error: null }
    case 'training-course/MARK_COMPLETED_ERROR':
      return {
        ...state,
        isSubmitting: false,
        isSubmitted: false,
        error: action.error,
      }
    default:
      return state
  }
}

export { dxTrainingCourse }
